import React from "react";
import { COIN_MODES, getCoinModeBalance, useCoinMode } from "../../context/CoinModeContext";
import { getGoldCoinName, getSweepsCoinName } from "../../utility/complianceCopy";

export default function CoinSwitcher({ wallet = {} }) {
  const { coinMode, setCoinMode } = useCoinMode();
  const choices = [
    { mode: COIN_MODES.GOLD, label: getGoldCoinName(), balance: getCoinModeBalance(wallet, COIN_MODES.GOLD) },
    {
      mode: COIN_MODES.DREAM,
      label: getSweepsCoinName(),
      balance: getCoinModeBalance(wallet, COIN_MODES.DREAM),
    },
  ];
  return (
    <div className="dts-coin-switcher" role="tablist" aria-label="Play currency">
      {choices.map(({ mode, label, balance }) => (
        <button key={mode} type="button" role="tab" aria-selected={coinMode === mode}
          className={coinMode === mode ? "active" : ""} onClick={() => setCoinMode(mode)}>
          <span>{label}</span><strong>{Number(balance || 0).toFixed(2)}</strong>
        </button>
      ))}
    </div>
  );
}
